/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Restricted_ChannelInputs */

const en_restricted_channel = /** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restricted Channel`)
};

const es_restricted_channel = /** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal Restringido`)
};

const fr_restricted_channel = /** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canal restreint`)
};

const de_restricted_channel = /** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingeschränkter Kanal`)
};

const id_restricted_channel = /** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saluran Terbatas`)
};

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const ja_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const zh_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const ar_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const it_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const ru_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const pt_restricted_channel = en_restricted_channel;

/** @type {(inputs: Restricted_ChannelInputs) => LocalizedString} */
const ko_restricted_channel = en_restricted_channel;

/**
* | output |
* | --- |
* | "Restricted Channel" |
*
* @param {Restricted_ChannelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const restricted_channel = /** @type {((inputs?: Restricted_ChannelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Restricted_ChannelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_restricted_channel(inputs)
	if (locale === "es") return es_restricted_channel(inputs)
	if (locale === "fr") return fr_restricted_channel(inputs)
	if (locale === "de") return de_restricted_channel(inputs)
	if (locale === "ja") return ja_restricted_channel(inputs)
	if (locale === "zh") return zh_restricted_channel(inputs)
	if (locale === "ar") return ar_restricted_channel(inputs)
	if (locale === "id") return id_restricted_channel(inputs)
	if (locale === "it") return it_restricted_channel(inputs)
	if (locale === "ru") return ru_restricted_channel(inputs)
	if (locale === "pt") return pt_restricted_channel(inputs)
	return ko_restricted_channel(inputs)
});